import Stack from "@mui/material/Stack";
import i18n from "../../../../constants/i18n";
import getUserMessagesStore from "../../../../stores/user-store/messages-store";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import KhattabatDataTable from "../../../../core/et3-table/KhattabatDataTable";
import LoadMoreButton from "./LoadMoreButton";
import KhattabatSocialMediaBadWordsCounter from "../../../../components/KhattabatSocialMediaBadWordsCounter";
import { USER_MESSAGES_HEADERS } from "../../../../constants/table-custom-headers/User";

const UserMessagesData = withLiteObserverAndTheme(() => {
  const searchedUser = getUserMessagesStore().searchedUser.get();
  const userMessagesData = getUserMessagesStore().userMessagesData.get();
  const messagesData = getUserMessagesStore().getMessagesData(
    userMessagesData,
    searchedUser
  );
  const socialMediaBadWordsCount =
    getUserMessagesStore().getBadWordsAndSocialMediaCount(messagesData);

  return (
    <Stack spacing={2}>
      <KhattabatSocialMediaBadWordsCounter
        socialMediaBadWordsCount={socialMediaBadWordsCount}
      />
      <KhattabatDataTable
        columns={USER_MESSAGES_HEADERS}
        rows={messagesData}
        title={i18n.get("USER_MESSAGES_TABLE")}
        shouldBeFlagged={false}
        titleKey={"USER_MESSAGES_TABLE"}
      />
      <LoadMoreButton />
    </Stack>
  );
});
export default UserMessagesData;
